<template>
  <el-dialog :title="title" :visible.sync="visible" :before-close="closeDialog" @closed="closeDialog" width="30%" @open="addOpen" :close-on-click-modal="false">
    <el-form :model="formData" :rules="addFormRules" ref="addFormRef" label-width="80px">
      <el-form-item label="名称" prop="title">
        <el-input v-model="formData.title"></el-input>
      </el-form-item>
      <el-form-item label="域名" prop="domain">
        <el-input v-model="formData.domain"></el-input>
      </el-form-item>
      <el-form-item label="发件人" prop="send_user">
        <el-input v-model="formData.send_user"></el-input>
      </el-form-item>
      <el-form-item label="密钥" prop="api_key">
        <el-input v-model="formData.api_key"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="addConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'mailgun_add',
  props: [
    'visible', 'id'
  ],
  data () {
    return {
      title: '添加Mailgun',
      formData: {
        title: '',
        domain: '',
        send_user: '',
        api_key: ''
      },
      addFormRules: {
        title: [
          { required: true, message: '名称不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    closeDialog () {
      this.$refs.addFormRef.resetFields()
      this.$emit('closeDialog')
    },
    addConfirm () {
      this.$refs.addFormRef.validate(valid => {
        if (!valid) return
        // 验证通过
        if (this.id === 0) {
          this.$emit('add', this.formData)
        } else {
          this.$emit('update', this.id, this.formData)
        }
      })
    },
    addOpen () {
      // 如果id>0,则是编辑信息
      if (this.id > 0) {
        this.title = '编辑Mailgun'
        this.getInfo(this.id)
      } else {
        this.title = '添加Mailgun'
      }
    },
    async getInfo (id) {
      const res = await this.$http.get('/admin/mailgun/info/' + id)
      if (res.code === 0) {
        this.formData = {
          title: res.data.title,
          domain: res.data.domain,
          send_user: res.data.send_user,
          api_key: res.data.api_key
        }
      }
    }
  }
}
</script>

<style scoped>
</style>
